import { useCallback } from "react";

import type { IUserSubprofileModel } from "../models";
import { useConfigurationSelector } from "../selectors";

export const useInitialHomePage = () => {
  const configuration = useConfigurationSelector();

  const getInitialHomePage = useCallback(
    (subProfile?: IUserSubprofileModel): string => {
      const profileInitialPage = subProfile?.InitialHomePage;

      if (subProfile?.Child) {
        return configuration?.Routes?.KIDS || "/";
      }

      return (profileInitialPage ?? configuration?.Routes?.HOME) as string;
    },
    [configuration]
  );

  return { getInitialHomePage };
};
